<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('edit_customer_info') }}
      v-divider.basic300
      v-card-text.pb-0.px-4.pt-4
        v-form(ref="form")
          .name
            p.mb-0.label.basic600--text.text-uppercase {{ $t('name.label') }}
            v-text-field.mt-2(v-model='customer.name' :placeholder="$t('name.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.not_empty")

          .phone
            p.mb-0.label.basic600--text.text-uppercase {{ $t('phone.label') }}
            v-text-field.mt-2(v-model='customer.phone' :placeholder="$t('phone.placeholder')" background-color="basic200" height="40" type="tel" outlined dense persistent-hint :rules="rules.phone" @keypress="isNumber($event)")

          .email
            p.mb-0.label.basic600--text.text-uppercase {{ $t('email.label') }}
            v-text-field.mt-2(v-model='customer.email' :placeholder="$t('email.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="customer.email ? rules.valid_email : []" type="email")

          .status
            p.mb-0.label.basic600--text.text-uppercase {{ lead.paid ? $t('order_status.label') : $t('lead_status.label') }}
            v-select.mt-2(v-model='customer.status' :placeholder="lead.paid? $t('order_status.placeholder') : $t('lead_status.placeholder')" background-color="basic200" height="40" :items="(lead.paid || lead.cod || lead.pay_at_shop) ? paidStatusSelections : statusSelections" item-value="id" item-text="name" outlined dense)

          .remarks(v-if="Auth('root', 'lead_remarks')")
            p.mb-0.label.basic600--text.text-uppercase {{ $t('remarks.label') }}
            v-textarea.mt-2(v-model="customer.remarks" :placeholder="$t('remarks.placeholder')" background-color="basic200" outlined dense persistent-hint auto-grow rows="3")
          
          .extrainfo(v-if="customer.extra_fields_data")
            template(v-for="(extra_field, index) in customer.extra_fields_data")
              template(v-if="extra_field.enabled")
                .text(v-if="extra_field.type == 'text'")
                  p.mb-0.label.basic600--text.text-uppercase {{ extra_field.name }}
                  v-text-field.mt-2(v-model="extrafields[index]" :placeholder="extra_field.name" outlined background-color="basic200" height="40" dense :rules="extra_field.required ? rules.not_empty : []")
                .dropdown(v-if="extra_field.type == 'dropdown'")
                  p.mb-0.label.basic600--text.text-uppercase {{ extra_field.name }}
                  v-select.mt-2(v-model="extrafields[index]"  outlined background-color="basic200" height="40" dense :rules="extra_field.required ? rules.not_empty : []" :items="extra_field.choices")
                .checklist.mb-8(v-if="extra_field.type == 'checklist'")
                  p.mb-2.label.basic600--text.text-uppercase {{ extra_field.name }}
                  template(v-for="(choice, i) in extra_field.choices")
                    y-checkbox.mb-1(v-model="customer.extra_fields_data[index].checklist_data[i]" hide-details @change="saveCheck(index)")
                      template(v-slot:label)
                        div.p1.my-auto {{ choice }}
                .date(v-if="extra_field.type == 'date'")
                  p.mb-0.label.basic600--text.text-uppercase {{ extra_field.name }}
                  //- v-text-field.mt-2(:value="extrafields[index]" placeholder="Select date" outlined background-color="basic200" height="40" dense :rules="extra_field.required ? rules.not_empty : []" readonly @click="openDateDialog(index)")
                  y-dialog(v-model="customer.extra_fields_data[index].show" max-width="320px")
                    template(v-slot:activator='{ on }')
                      v-text-field.mt-2(v-model="extrafields[index]" placeholder="Select date" outlined background-color="basic200" height="40" dense :rules="extra_field.required ? rules.not_empty : []" readonly v-on='on')
                    v-date-picker.pt-6(v-model="customer.extra_fields_data[index].date" color="textColorAccent" @change="saveDate(index)" no-title)
                .date(v-if="extra_field.type == 'delivery_date'")
                  p.mb-0.label.basic600--text.text-uppercase {{ extra_field.name }}
                  y-dialog(v-model="customer.extra_fields_data[index].show" max-width="320px")
                    template(v-slot:activator='{ on }')
                      v-text-field.mt-2(v-model="extrafields[index]" placeholder="Select date" outlined background-color="basic200" height="40" dense :rules="extra_field.required ? rules.not_empty : []" readonly v-on='on')
                    v-date-picker.pt-6(v-model="customer.extra_fields_data[index].date" color="textColorAccent" @change="saveDate(index)" :min="getMinDayBefore(extra_field.min_day_before)" no-title)
                .date(v-if="extra_field.type == 'time'")
                  p.mb-0.label.basic600--text.text-uppercase {{ extra_field.name }}
                  y-dialog(v-model='customer.extra_fields_data[index].show' max-width="320px")
                    template(v-slot:activator='{ on }')
                      v-text-field.mt-2(v-model="extrafields[index]" placeholder="Select time" outlined background-color="basic200" height="40" dense :rules="extra_field.required ? rules.not_empty : []" readonly v-on='on')
                    v-time-picker(v-model='customer.extra_fields_data[index].time' color="textColorAccent")
                      v-btn.button-AA-medium.mt-3.white--text(color="textColorAccent" dark small height="40" block @click="saveTime(index)") set
                .date(v-if="extra_field.type == 'delivery_time'")
                  p.mb-0.label.basic600--text.text-uppercase {{ extra_field.name }}
                  y-dialog(v-model='customer.extra_fields_data[index].show' max-width="320px")
                    template(v-slot:activator='{ on }')
                      v-text-field.mt-2(v-model="extrafields[index]" placeholder="Select time" outlined background-color="basic200" height="40" dense :rules="extra_field.required ? rules.not_empty : []" readonly v-on='on')
                    v-time-picker(v-model='customer.extra_fields_data[index].time' color="textColorAccent" :min="extra_field.start_time" :max="extra_field.end_time")
                      v-btn.button-AA-medium.mt-3.white--text(color="textColorAccent" dark small height="40" block @click="saveTime(index)") set
                .long_text(v-if="extra_field.type == 'long_text'")
                  p.mb-0.label.basic600--text.text-uppercase {{ extra_field.name }}
                  v-textarea.mt-2(v-model="extrafields[index]" :placeholder="extra_field.hint"  background-color="basic200" outlined dense auto-grow rows="3" :rules="extra_field.required ? rules.not_empty : []")

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 :loading="isUpdating" @click='clickUpdate' dark)
          .button-AA-small.basic100--text {{ $t('update_info') }}

</template>

<script>
import { DateTime } from 'luxon'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EditCustomerInfoDialog',
  props: ['open', 'parentLead'],
  data: (v) => ({
    dateDialog: false,
    datePicker: null,
    dateIndex: null,
    customer: {
      name: v.parentLead.name,
      phone: v.parentLead.phone,
      email: v.parentLead.email,
      status: v.parentLead.status,
      remarks: v.parentLead.remarks,
      extra_fields_data: v.parentLead.extra_fields_data,
    },
    extrafields: [],
    isUpdating: false,
    statusSelections: [
      { 
        name: 'New',
        id: 'new'
      },
      { 
        name: 'Follow up',
        id: 'follow_up'
      },
      { 
        name: 'Partial payment',
        id: 'partial_payment'
      },
      { 
        name: 'Reject',
        id: 'reject'
      }
    ],
    paidStatusSelections: [
      { 
        name: 'Processed',
        id: 'processed'
      },
      { 
        name: 'Shipped',
        id: 'shipped'
      },
      { 
        name: 'Received',
        id: 'received'
      },
      { 
        name: 'cancelled',
        id: 'cancelled'
      }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      phone: [v => !!v || 'Phone Number is required'],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address']
    }
  }),
  computed: {
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    ...mapGetters({
      company: 'getCompany'
    })
  },
  mounted () {
    this.extrafields = this.lead.extra_fields_data.map(m => m.value)
    if (this.customer.extra_fields_data && this.customer.extra_fields_data.length > 0) {
      this.customer.extra_fields_data.forEach(o => {
        if (o.type === 'date' || o.type === 'delivery_date') {
          const dt = o.value.split('/')
          let date = `${dt[2]}-${dt[1]}-${dt[0]}`
          let show = false
          o = { ...o, date, show }
        } else if (o.type === 'time' || o.type === 'delivery_time') {
          let show = false
          let time = ''
          o = { ...o, time, show }
        } else if (o.type === 'checklist') {
          let splitvalue = o.value.split(', ')
          this.$set(o, 'checklist_data', [])
          o.choices.forEach(r => {
            if ([...splitvalue].includes(r)) {
              o.checklist_data.push(true)
            } else {
              o.checklist_data.push(false)
            }
          })
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickUpdate() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isUpdating = true
      if (this.customer.extra_fields_data) {
        this.customer.extra_fields_data.forEach((o, idx) => {
          o.value = this.extrafields[idx]
        })
      }
      this.axios.patch(`/leads/${this.lead.pid}/`, this.customer)
        .then(resp => {
          this.$set(this.lead, 'email', resp.data.email)
          this.$set(this.lead, 'extra_fields_data', resp.data.extra_fields_data)
          this.$set(this.lead, 'name', resp.data.name)
          this.$set(this.lead, 'phone', resp.data.phone)
          this.$set(this.lead, 'remarks', resp.data.remarks)
          this.$set(this.lead, 'status', resp.data.status)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUpdating = false
        })
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    saveDate (index) {
      // this.$set(this.customer.extra_fields_data[index], 'value', this.formatDate(this.customer.extra_fields_data[index].date))
      this.extrafields[index] = this.formatDate(this.customer.extra_fields_data[index].date)
      this.$set(this.customer.extra_fields_data[index], 'show', false)
    },
    saveTime (index) {
      // this.$set(this.customer.extra_fields_data[index], 'value', this.formatTime(this.customer.extra_fields_data[index].time))
      this.extrafields[index] = this.formatTime(this.customer.extra_fields_data[index].time)
      this.$set(this.customer.extra_fields_data[index], 'show', false)
    },
    saveCheck (index) {
      let selectedString = ''
      this.customer.extra_fields_data[index].checklist_data.forEach((data, idx) => {
        if (data) {
          if (selectedString.length > 0) {
            selectedString = selectedString.concat(', ')
          }
          selectedString = selectedString.concat(this.customer.extra_fields_data[index].choices[idx])
        }
      })
      this.extrafields[index] = selectedString
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatTime (time24) {
      let ts = time24
      const H = +ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'AM' : 'PM'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    },
    getMinDayBefore (day) {
      return DateTime.local().plus({ days: day }).toFormat('yyyy-MM-dd')
    },
    openDateDialog (index) {
      this.datePicker = this.extrafields[index]
      this.openDateDialog = true
    },
    // onChangeDate ()
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "name": {
      "label": "Name",
      "placeholder": "Customer name"
    },
    "email": {
      "label": "Email",
      "placeholder": "Customer email"
    },
    "phone": {
      "label": "Phone",
      "placeholder": "Customer phone no"
    },
    "lead_status": {
      "label": "Lead Status",
      "placeholder": "Lead Status"
    },
    "remarks": {
      "label": "Remarks",
      "placeholder": "Customer remarks"
    },
     "order_status": {
      "label": "Order Status",
      "placeholder": "Order Status"
    },
    "update_info": "Update Info"
  },
  "id": {
    "name": {
      "label": "Nama",
      "placeholder": "Nama Pelanggan"
    },
    "email": {
      "label": "Email",
      "placeholder": "Email Pelanggan"
    },
    "phone": {
      "label": "Telepon",
      "placeholder": "Nomor HP"
    },
    "lead_status": {
      "label": "Status Lead",
      "placeholder": "Status Lead"
    },
    "remarks": {
      "label": "Catatan",
      "placeholder": "Catatan Pelanggan"
    },
     "order_status": {
      "label": "Status Order",
      "placeholder": "Status Order"
    },
    "update_info": "Perbarui Info"
  }
}
</i18n>
